import CandidateEducationItem, { CandidateEducationItemType } from '../CandidateEducationItem';

const CandidateEducation = (props: CandidateEducationItemType): JSX.Element => {
  return <CandidateEducationItem {...props} />;
};

export default CandidateEducation;
